import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

/**
 * Campo select
 */
@Component({
    selector: 'app-dropdown',
    template: `
      <div [formGroup]="form">
        <select
        class="form-control"
        (change)="change($event.target)"
        [id]="field.name"
        [formControlName]="field.name"
        [disabled]="field.disabled"
        [value]="field.value"
        [(ngModel)]="field.value"
        >
        <option *ngFor="let opt of field.options" [value]="opt.key">{{opt.label}}</option>
        </select>
      </div>
    `,
    standalone: false
})
export class DropDownComponent {
  /**
   * Campo del formulario
   */
  @Input() field: any;
  /**
   * Formulario
   */
  @Input() form!: UntypedFormGroup;

  /**
   * Constructor
   */
  constructor(
  ) {
    setTimeout(() => {
      // this.form.controls[this.field.name].setValue(this.field.value);
    }, 200);
  }

  /**
   * Indica los cambios del campo
   *
   * @param field campo seleccionado
   */
  change(field: any): void {
  }
}
